import { makeStyles } from '@mui/styles';

const useBusinessGroupsContainerStyles = makeStyles({
	box: {
		background: 'white',
		height: 'auto',
		borderRadius: '20px',
		maxHeight: '90vh',
		margin: 'auto',
		width: '90%',
	},
	root: {
		marginTop: '5%',
	},
	containerTitle: {
		paddingLeft: '5% !important',
		color: '#003C82',
		fontFamily: 'Montserrat',
		fontWeight: 'bold',
		fontSize: 16,
		width: 'auto',
		float: 'left',
	},
	filters: {
		width: '92%',
		marginTop: 0,
		marginRight: 46,
		marginBottom: '15px',
	},
	filtersOpen: {
		width: '93%',
		marginBottom: '15px',
	},
	tooltip: {
		fontSize: '10px !important',
		fontFamily: 'Montserrat, Medium',
		backgroundColor: '#686868 !important',
		color: 'white !important',
		borderRadius: '10px !important',
		width: 'auto',
		textAlign: 'center',
		padding: '4px 12px !important',
		marginTop: '-5px !important',
	},
	arrow: {
		color: 'white !important',
	},
	paginator: {
		padding: '20px 30px 0px 0px',
		marginTop: 15,
		width: '100%',
	},
	divList: {
		position: 'relative',
		padding: 1,
		background: 'white',
		zIndex: '1',
		boxShadow: '0px 3px 6px #00000029',
		width: '87%',
		borderBottomLeftRadius: '6px !important',
		borderBottomRightRadius: '6px !important',
	},
	ulClients: {
		listStyle: 'none',
		color: '#707070',
		fontSize: 16,
		padding: 0,
		width: '90%',
		margin: '4% auto',
	},
	liClients: {
		cursor: 'pointer',
	},
	th: {
		fontFamily: 'Montserrat',
		color: '#003C82',
		fontWeight: 'bold',
		textAlign: 'left',
		fontSize: '12px',
	},
	td: {
		color: '#1A1233',
		fontFamily: 'Montserrat',
		fontWeight: '500',
		fontSize: '12px',
		padding: '0',
	},
	table: {
		width: '100%',
		margin: 'auto',
		borderCollapse: 'collapse',
	},
	tr: {
		borderBottom: '1px solid #00000029',
	},
});

export default useBusinessGroupsContainerStyles;
